import { API_BASE, apiDelete, apiGet, apiPatch, apiPost, apiPut, readSessionToken } from '@/lib/api';

export const fetchChildProfiles = () => apiGet('/parent/profiles');
export const addChildProfile = (payload) => apiPost('/parent/profiles', payload);
export const patchChildProfile = (id, payload) => apiPatch(`/parent/profiles/${id}`, payload);
export const removeChildProfile = (id) => apiDelete(`/parent/profiles/${id}`);
export const activateChildProfile = (id) => apiPost(`/parent/profiles/${id}/activate`, {});

export const fetchThemePresets = () => apiGet('/themes/presets');
export const unlockTheme = (preset) => apiPost('/themes/unlock', { preset });
// First-run theme step is offered once; "Set up later" also marks it seen.
export const markThemeSetupSeen = () => apiPost('/themes/setup-seen', {});
export const saveTheme = (preset, profileId, clearBackground = false) =>
  apiPut(`/themes${profileId ? `?profile_id=${encodeURIComponent(profileId)}` : ''}`,
    { preset, clear_background: clearBackground });

export async function uploadThemeBackground(file, profileId) {
  const body = new FormData();
  body.append('file', file);
  const qs = profileId ? `?profile_id=${encodeURIComponent(profileId)}` : '';
  const res = await fetch(`${API_BASE}/themes/background${qs}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${readSessionToken()}` },
    credentials: 'include',
    body,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.detail || 'Upload failed');
  return data;
}

// <img>/CSS background can't send an Authorization header, so the token rides
// as a query param on this one read-only route.
export const themeBackgroundUrl = (path) =>
  path ? `${API_BASE}/themes/background/${path}?auth=${encodeURIComponent(readSessionToken() || '')}` : null;

export const CLASS_OPTIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
